/**
 * Formats the props object for the videos list component
 * from video player options
 * @return {Object}
 */
const extractVideosListProps = options => {
  let playlistObj = {
    animationHandler: options.animationHandler,
    currentlyViewedEntryId: options.planEntryId,
    enable: options.enable,
    planSubscriptionId: options.planSubscriptionId,
    playlistPos: options.playlistPos,
    title: options.listEntriesInformation.title,
    type: options.originType,
    entryListOrigin: options.listEntriesInformation
  }
  if (options.originType === 'playlist') {
    playlistObj = Object.assign({}, playlistObj, {
      playlistUUID: options.uuid,
      showPlanTitle: true
    })
  } else if (options.originType === 'series') {
    let coach = options.listEntriesInformation.coaches[0]
    playlistObj = Object.assign({}, playlistObj, {
      coachName: coach ? `${coach.firstName} ${coach.lastName}` : '',
      background: options.listEntriesInformation.coverPhoto.url
    })
  }
  return playlistObj
}

export default extractVideosListProps
